module.exports = "/img/31.f44502.webp";